import { Action } from 'redux';

export { isLoading, doneLoading } from '../config/actions';

// --- Action Types ---

// Get all
export const GET_IMAGE_CATALOG = 'image-catalog/GET_IMAGE_CATALOG';
export interface GetImageCatalogAction extends Action<typeof GET_IMAGE_CATALOG> {}

// Get by id
export const GET_IMAGE_CATALOG_ASSET = 'image-catalog/GET_IMAGE_ASSET';
export interface GetImageCatalogAssetAction extends Action<typeof GET_IMAGE_CATALOG_ASSET> {
  readonly payload: number | string;
}

// Post to create
export const CREATE_IMAGE_CATALOG_ASSET = 'image-catalog/CREATE_IMAGE_CATALOG_ASSET';
export interface CreateImageCatalogAssetAction extends Action<typeof CREATE_IMAGE_CATALOG_ASSET>, OnCompleteAction {
  readonly payload?: ImageCatalogAssetFormValues;
}

// Delete
export const DESTROY_IMAGE_CATALOG_ASSET = 'image-catalog/DESTROY_IMAGE_CATALOG_ASSET';
export interface DestroyImageCatalogAssetAction extends Action<typeof DESTROY_IMAGE_CATALOG_ASSET>, OnCompleteAction {
  readonly payload: ImageCatalogAsset;
}

// Reducer Actions
export const CLEAR_IMAGE_CATALOG = 'image-catalog/CLEAR_IMAGE_CATALOG';
export interface ClearImageCatalogAction extends Action<typeof CLEAR_IMAGE_CATALOG> {}

export const GENERATE_IMAGE_ASSET = 'image-catalog/GENERATE_IMAGE_ASSET';
export interface GenerateImageAssetAction extends Action<typeof GENERATE_IMAGE_ASSET> {}

export const UPDATE_IMAGE_CATALOG_ASSET = 'image-catalog/UPDATE_IMAGE_CATALOG_ASSET';
export interface UpdateImageCatalogAssetAction extends Action<typeof UPDATE_IMAGE_CATALOG_ASSET>, OnCompleteAction {
  readonly payload: ImageCatalogAsset;
}

export const CLEAR_IMAGE_ASSET = 'image-catalog/CLEAR_IMAGE_ASSET';
export interface ClearImageAssetAction extends Action<typeof CLEAR_IMAGE_ASSET> {}

export const SAVE_IMAGE_CATALOG = 'image-catalog/SAVE_IMAGE_CATALOG';
export interface SaveImageCatalogAction extends Action<typeof SAVE_IMAGE_CATALOG> {
  readonly payload: Array<ImageCatalogAsset>;
}

export type ImageCatalogAction =
  | GetImageCatalogAction
  | GetImageCatalogAssetAction
  | CreateImageCatalogAssetAction
  | DestroyImageCatalogAssetAction
  | ClearImageCatalogAction
  | GenerateImageAssetAction
  | UpdateImageCatalogAssetAction
  | ClearImageAssetAction
  | SaveImageCatalogAction;

// --- Actions ---

export const getImageCatalog = (): GetImageCatalogAction => ({
  type: GET_IMAGE_CATALOG,
});

export const getImageCatalogAsset = (id: number): GetImageCatalogAssetAction => ({
  payload: id,
  type: GET_IMAGE_CATALOG_ASSET,
});

export const createImageCatalogAsset = (
  asset: ImageCatalogAssetFormValues,
  onComplete?: () => void,
): CreateImageCatalogAssetAction => ({
  meta: {
    onComplete,
  },
  payload: asset,
  type: CREATE_IMAGE_CATALOG_ASSET,
});

export const destroyImageCatalogAsset = (
  asset: ImageCatalogAsset,
  onComplete?: () => void,
): DestroyImageCatalogAssetAction => ({
  meta: {
    onComplete,
  },
  payload: asset,
  type: DESTROY_IMAGE_CATALOG_ASSET,
});

export const clearImageCatalog = (): ClearImageCatalogAction => ({
  type: CLEAR_IMAGE_CATALOG,
});

export const generateImageAsset = (): GenerateImageAssetAction => ({
  type: GENERATE_IMAGE_ASSET,
});

export const updateImageCatalogAsset = (
  asset: ImageCatalogAsset,
  onComplete?: () => void,
): UpdateImageCatalogAssetAction => ({
  meta: {
    onComplete,
  },
  payload: asset,
  type: UPDATE_IMAGE_CATALOG_ASSET,
});

export const clearImageAsset = (): ClearImageAssetAction => ({
  type: CLEAR_IMAGE_ASSET,
});

export const saveImageCatalog = (catalog: Array<ImageCatalogAsset>): SaveImageCatalogAction => ({
  type: SAVE_IMAGE_CATALOG,
  payload: catalog,
});
